export const SESSION_WARNING_TITLE_ID = 'session-lifetime-warning-title';
export const SESSION_WARNING_DESCRIPTION_ID = 'session-lifetime-warning-description';

export const SESSION_WARNING_STATES = Object.freeze({
  HARD_60: 'hard_60',
  HARD_10: 'hard_10',
  ENDED: 'ended',
});

function buildButton({label, classes}) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = [
    'sm-button',
    'session-lifetime-warning__action',
    ...classes,
  ].join(' ');
  button.textContent = label;
  return button;
}

function remainingLabel(minutesRemaining) {
  const minutes = Math.max(1, Math.ceil(Number(minutesRemaining) || 1));
  if (minutes === 60) return 'about 1 hour';

  return `about ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
}

function buildWarningTitle(minutesRemaining) {
  const title = document.createElement('h2');
  title.id = SESSION_WARNING_TITLE_ID;
  title.className = 'sm-modal-header__title';
  title.append('Your session will end in ');

  const countdown = document.createElement('span');
  countdown.className = 'js-session-lifetime-countdown';
  countdown.textContent = remainingLabel(minutesRemaining);
  title.append(countdown);

  return title;
}

function buildActions(state) {
  const actions = document.createElement('div');
  actions.className = [
    'session-lifetime-warning__actions',
    'sm-cluster',
    'sm-cluster--m',
    'sm-cluster--actions',
  ].join(' ');

  if (state === SESSION_WARNING_STATES.ENDED) {
    actions.append(buildButton({
      label: 'Sign in again',
      classes: ['sm-button--primary', 'js-session-lifetime-sign-in-again'],
    }));
    return actions;
  }

  actions.append(
    buildButton({
      label: 'I\'ve saved my work - sign in again',
      classes: ['sm-button--neutral', 'js-session-lifetime-sign-in-again'],
    }),
    buildButton({
      label: 'Continue working',
      classes: [
        'sm-button--primary',
        'js-session-lifetime-continue',
      ],
    })
  );
  return actions;
}

export function buildSessionLifetimeWarningContent({state, minutesRemaining = 10}) {
  if (!Object.values(SESSION_WARNING_STATES).includes(state)) {
    throw new Error(`Unsupported session warning state: ${state}`);
  }

  const content = document.createElement('div');
  content.className = 'session-lifetime-warning sm-modal js-session-lifetime-warning';
  content.dataset.warningState = state;

  const header = document.createElement('div');
  header.className = 'sm-modal-header';

  const title = state === SESSION_WARNING_STATES.ENDED
    ? document.createElement('h2')
    : buildWarningTitle(minutesRemaining);
  if (state === SESSION_WARNING_STATES.ENDED) {
    title.id = SESSION_WARNING_TITLE_ID;
    title.className = 'sm-modal-header__title';
    title.textContent = 'Your session ended';
  }
  header.append(title);

  const body = document.createElement('div');
  body.id = SESSION_WARNING_DESCRIPTION_ID;
  body.className = 'session-lifetime-warning__body sm-stack sm-stack--l';

  const message = document.createElement('p');
  message.className = 'sm-typestyle sm-typestyle--body-default';
  message.textContent = state === SESSION_WARNING_STATES.ENDED
    ? 'Sign in again to continue.'
    : 'This session has reached its maximum age. Save your work before signing in again.';
  body.append(message, buildActions(state));
  content.append(header, body);

  return content.outerHTML;
}

export function sessionLifetimeRemainingLabel(minutesRemaining) {
  return remainingLabel(minutesRemaining);
}
